import React from 'react';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
  IonContent,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonLoading,
  IonToast,
} from '@ionic/react';
import { homeOutline, cartOutline, personOutline, cubeOutline, receiptOutline, settingsOutline } from 'ionicons/icons';

import PosActions from '../../actions/PosActions';
import { getLoginApp, getPermissions } from '../../utils/functions';

import ConfigurationProduct from './configuration/ConfigurationProduct';
import ListProducts from '../products/listProducts/listProduct';

interface IProps {
  setData_: any;
  get_: any;
}

interface IState {
  simpleToast: any;
  response: any;
  datalogin: any;
  loading: any;
  data_default: any;

}

class DashboardProducts extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props)
    this.state = {
      response: props.response,
      simpleToast: props.simpleToast,
      datalogin: props.datalogin,
      loading: props.loading,
      data_default: props.data_default

    }
  }

  componentDidMount() {
    this.props.get_({
      typeOption: 'get_data_default',
      user_id: getLoginApp().id,
    }, "api/get_data_default");
  }

  UNSAFE_componentWillReceiveProps(nextProps: any) {
    this.setState({
      simpleToast: nextProps.data.simpleToast,
      response: nextProps.data.response,
      loading: nextProps.data.loading,

    });
  }
  onDidDismissToast(e: any) {
    this.props.setData_({ response: {}, simpleToast: false });
  }

  render() {
    const { simpleToast, response, loading } = this.state;
    return (
      <IonContent fullscreen scrollEvents={true} style={{ boderRadius: '10px' }}>
        <IonLoading
          //color="light"
          cssClass='my-custom-class'
          isOpen={!!(loading && loading.isOpen)}
          message={`${loading && loading.Msg ? loading.Msg : ''}`}
        />
        {
          response && response.Msg ? (
            <IonToast
              isOpen={!!simpleToast}
              color={response && response.success == 1 ? 'success' : 'danger'}
              position='top'
              message={`${response && response.Msg ? response.Msg : ''}`}
              duration={1500}
              onDidDismiss={e => this.onDidDismissToast(e)}
            />
          ) : null
        }

        <IonTabs>
          <IonRouterOutlet >
            <Route path="/dashboard_products/configuration" component={ConfigurationProduct} exact={true} />
            <Route path="/dashboard_products/listProducts" component={ListProducts} exact={true} />

          </IonRouterOutlet>

          <IonTabBar slot="bottom">
            <IonTabButton tab="dashboard_products/listProducts" href={`/dashboard_products/listProducts`}>
              <IonIcon icon={cubeOutline} />
              <IonLabel>Producto</IonLabel>
            </IonTabButton>
            <IonTabButton tab="dashboard_products/configuration" href={`/dashboard_products/configuration`} >
              <IonIcon icon={settingsOutline} />
              <IonLabel>Configuración</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonContent>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    data: state.data,

  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setData_: (data: any, name: string) => dispatch(PosActions.setData(data, name)),
    get_: (fields: any, controller: string) => dispatch(PosActions.get_(fields, controller)),

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardProducts);
